import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import type { AboutDetail } from "src/types";
import styled from "styled-components";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import RichText from "@/components/editor/primitives/rich-text";
import Text from "@/components/editor/primitives/text/text-component";
import useRichTextCompatible from "@/hooks/use-rich-text-compatible";

export default function AboutDetailsItem(props: AboutDetail) {
  const {
    connectors: { connect },
    nodeId,
  } = useNode((node) => ({ nodeId: node.id }));

  const isRichTextCompatible = useRichTextCompatible(nodeId, [
    "about-details-item-title",
    "about-details-item-description",
  ]);

  return (
    <Wrapper ref={connect} data-testid="about-details-item">
      {isRichTextCompatible ? (
        <>
          <Element
            id="about-details-item-title"
            is={RichText}
            text={`<h4>${props.paragraphHeading}</h4>`}
          />
          <Element
            id="about-details-item-description"
            is={RichText}
            text={`<p>${props.paragraph}</p>`}
          />
        </>
      ) : (
        <>
          <Element
            id="about-details-item-title"
            is={Text}
            text={props.paragraphHeading}
            element="h3"
            pattern="headingThree"
          />
          <Element
            id="about-details-item-description"
            is={Text}
            text={props.paragraph}
            pattern="description"
          />
        </>
      )}
    </Wrapper>
  );
}

AboutDetailsItem.craft = {
  custom: {
    displayName: "About Details Item",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};

const Wrapper = styled.div`
  .headingThree {
    margin: 0;
  }

  .ck-content p {
    font-size: ${rem(14)} !important;
    line-height: ${rem(26)} !important;
  }

  & > :first-child {
    margin-bottom: ${rem(8)};
  }
`;
